import { useMemo } from "react"

import { SWAP_SLIPPAGE_DEFAULT_VALUE } from "#/shared/constants"
import { SwapFormValue } from "#/shared/types"

import { BaseModalProps } from "../BaseModal"
import { ComponentStepProps, StepperModal } from "../StepperModal"

import SwapModalBase from "./SwapModalBase"
import SwapReview from "./SwapReview"

export default function SwapModal({ ...props }: BaseModalProps) {
  const contextValue = useMemo<SwapFormValue>(
    () => ({
      sellToken: { amount: "", token: "mBTC" },
      buyToken: { amount: "", token: "MUSD" },
      slippage: SWAP_SLIPPAGE_DEFAULT_VALUE.toString(),
    }),
    [],
  )

  const steps = useMemo(
    () => [
      {
        title: "Swap",
        component: (stepProps: ComponentStepProps) => (
          <SwapModalBase {...stepProps} />
        ),
        withCloseButton: true,
      },
      {
        title: " ",
        component: (stepProps: ComponentStepProps) => (
          <SwapReview {...stepProps} />
        ),
        withBackButton: true,
        withCloseButton: false,
      },
    ],
    [],
  )

  return (
    <StepperModal
      closeable
      height="min-content"
      {...props}
      steps={steps}
      initialContextValue={contextValue}
    />
  )
}
